import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('bookings', {
        template: require('./booking.html'),
        controller: BookingsCtrl,
        controllerAs: 'vm'
    });

    BookingsCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$filter',
        '$cookies',
        'ModalService',
        'QueryService',
        'logger'
    ];

    function BookingsCtrl(
        $scope,
        $state,
        $stateParams,
        $filter,
        $cookies,
        ModalService,
        QueryService,
        logger
    ) {
        var vm = this;
        vm.user = { id: $stateParams.id };

        vm.route_name = 'douhgfyasssoid';
        vm.loading = false;
        vm.handleDelete = handleDelete;
        vm.getData = getData;

        //config
        vm.dates = [
            '2020-01-27',
            // '2020-01-28',
            // '2020-01-29',
            // '2020-01-30',
            // '2020-01-31',
        ];
        vm.times = [
            '07:00 am',
            // '07:40 am',
            // '08:20 am',
            // '09:00 am',
            // '09:40 am',
            // '10:20 am',
            // '11:40 am',
            // '12:20 pm',
            // '01:00 pm',
            // '01:40 pm',
            // '02:20 pm',
            // '03:00 pm',
            // '03:40 pm',
            // '04:20 pm',
            // '05:00 pm',
            // '05:40 pm',
            // '06:20 pm',
        ];


        function getData(key, hour, day) {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                hasFile: false,
                route: { booking: '' },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.data = response.data.data.items;
                        console.log(vm.data);
                        vm.loaded_data = 1;
                    },
                    function(error) {
                        logger.error(error.data.message);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        getSettings();
        function getSettings() {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                hasFile: false,
                route: { settings: 'bookings' },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.data = response.data.data;
                        
                        vm.times = vm.data.times;
                        vm.infographic = vm.data.infographic;
                        vm.durations = vm.data.durations;

                        vm.dates = vm.data.dates
                            .sort((a,b)=> a-b)
                            .filter(a => new Date(a) > new Date())
                            // .slice(0, 5);

                        getData();

                    },
                    function(error) {
                        logger.error(error.data.message);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        function handleDelete(data) {
            var request = {
                method: 'DELETE',
                body: {},
                params: false,
                hasFile: false,
                route: { salary_rubrik: data.id }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        logger.success('Booking Deleted');
                        getData();
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                    vm.disable = false;
                });
        }

        vm.book = function(date, time) {
            const data = {
                start: new Date(`${date} ${time.start}`),
                teacher_id: vm.user.id,
                skype_id: vm.skype_id,
                skype_name: vm.skype_name,
                live_id: vm.live_id,
            };

            vm.loading = true;
            var request = {
                method: 'POST',
                body: data,
                hasFile: false,
                route: { booking: '' },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        logger.success(
                            `You have successfully booked ${date} ${time.start}`
                        );
                    },
                    function(error) {
                        console.log(error);
                        logger.error(
                            error.data.message || error.data.errors[0].message
                        );
                    }
                )
                .finally(function() {
                    getData();
                    vm.loading = false;
                });
        };

        vm.unbook = (date, time) => {
            vm.loading = true;
            var request = {
                method: 'DELETE',
                body: false,
                hasFile: false,
                route: { booking: vm.get_cell(date, time).booking_id },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.option_table.data = response.data.data.items;
                    },
                    function(error) {
                        console.log(error);
                        logger.error(
                            error.data.message || error.data.errors[0].message
                        );
                    }
                )
                .finally(function() {
                    getData();
                });
        };

        vm.get_cell = (date, time) => {
            if(vm.data && typeof vm.data.find === 'function'){

                return vm.data.find(
                    i =>
                    new Date(i.start).toISOString() ===
                    new Date(`${date} ${time.start}`).toISOString()
                    );
            }
        };

        vm.copyStringToClipboard = str => {

            str = `Skype ID:${str.skype_id}\,Skype Name:${str.skype_name}\nLive ID: ${str.live_id}`

            // Create new element
            var el = document.createElement('textarea');
            // Set value (string to be copied)
            el.value = str;
            // Set non-editable to avoid focus and move outside of view
            el.setAttribute('readonly', '');
            el.style = { position: 'absolute', left: '-9999px' };
            document.body.appendChild(el);
            // Select text inside element
            el.select();
            // Copy text to clipboard
            document.execCommand('copy');
            // Remove temporary element
            document.body.removeChild(el);

            logger.success(`Copied to Clipboard`);
        };
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/booking/booking.component.js